/** @see docs/DESIGN/VISUAL_LANGUAGE_V2.md — auth screen uses same motion as profile routes */
export const SIGN_IN_PATH = "/sign-in";

/** Rough stack depth for transition direction when history uses PUSH to a parent path. */
export function routeDepth(pathname) {
  if (!pathname || pathname === "/") return 0;
  if (pathname === SIGN_IN_PATH) return 0;
  return pathname.split("/").filter(Boolean).length;
}

/**
 * @param {{
 *   skipAnimation: boolean;
 *   navigationType: import("react-router-dom").NavigationType;
 *   fromPath: string;
 *   toPath: string;
 * }} input
 */
export function resolveTransitionVariant({ skipAnimation, navigationType, fromPath, toPath }) {
  if (skipAnimation || fromPath === toPath) return "initial";
  if (navigationType === "POP") return "back";
  if (navigationType === "REPLACE") {
    if (toPath === SIGN_IN_PATH && fromPath !== SIGN_IN_PATH) return "forward";
    if (fromPath === SIGN_IN_PATH && toPath === "/") return "back";
    return "fade";
  }

  const fromDepth = routeDepth(fromPath);
  const toDepth = routeDepth(toPath);
  if (toPath === SIGN_IN_PATH && fromPath !== SIGN_IN_PATH) return "forward";
  if (fromPath === SIGN_IN_PATH && toPath === "/") return "back";
  if (toDepth < fromDepth) return "back";
  if (toDepth > fromDepth) return "forward";
  if (toPath.length < fromPath.length && fromPath.startsWith(`${toPath}/`)) return "back";
  if (fromPath.length < toPath.length && toPath.startsWith(`${fromPath}/`)) return "forward";
  return "forward";
}
